/**
 * Use Case: Fetch Point Conversion Partners
 * Business logic for fetching the list of available Point Conversion partners.
 */

import type { PointConversionPartner } from "../model/RewardCatalogModel";
import type { IRewardCatalogRepository } from "../repository/IRewardCatalogRepository";
import { rewardCatalogContainer, TYPES } from "../../di/RewardCatalogModule";

/**
 * Fetch the list of available Point Conversion partners
 */
export const FetchPointConversionPartnersUseCase = async (): Promise<
  readonly PointConversionPartner[]
> => {
  const repository = rewardCatalogContainer.get<IRewardCatalogRepository>(
    TYPES.IRewardCatalogRepository
  );
  return repository.fetchPointConversionPartners();
};

